import React from "react";

import Button, { ButtonStyle } from "components/Button";
import Modal from "components/Modal";
import { DEFAULT_MODAL_BODY_ID, DEFAULT_MODAL_TITLE_ID } from "constants/modalTemplate";
import { ModalStore } from "store/modalStore";

type ConfirmModalProps = {
  data: ModalStore;
  closeModal: () => void;
  modalTitleId?: string;
  modalBodyId?: string;
};

export const ConfirmModal = ({
  data,
  closeModal,
  modalTitleId = DEFAULT_MODAL_TITLE_ID,
  modalBodyId = DEFAULT_MODAL_BODY_ID,
}: ConfirmModalProps) => {
  if (!data.confirm) return null;

  return (
    <Modal
      onClose={() => {
        data.confirm?.cancelAction && data.confirm.cancelAction();
        closeModal();
      }}
      isOpen={data.confirm.modalState === "open"}
    >
      <div className="relative flex h-[250px] w-[400px] flex-col items-center px-8 pb-5">
        <div className={`relative ${data.confirm.top ? data.confirm.top : "top-[64px]"} flex flex-col items-center`}>
          <div className="item-center flex items-center justify-center">
            <p className="ml-2 text-19" id={modalTitleId}>
              {data.confirm.confirmMessage}
            </p>
          </div>
          <p className="relative mt-4 text-16px" id={modalBodyId}>
            {data.confirm.subMessage}
          </p>
        </div>
        <div className="absolute bottom-0 flex justify-center gap-4 py-5">
          <div className="w-[160px]">
            <Button
              text={"キャンセル"}
              onClick={() => {
                data.confirm?.cancelAction && data.confirm.cancelAction();
                closeModal();
              }}
              style={ButtonStyle.OUTLINE}
            />
          </div>
          <div className="w-[160px]">
            <Button
              text={data.confirm.positiveButtonText}
              onClick={data.confirm.positiveAction}
              style={ButtonStyle.PRIMARY}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
